import Pageheader from 'components/Pageheader';
import ModalMemberNotFound from 'components/modal/ModalMemberNotFound';
import ModalContext from 'contexts/ModalContext';
import React, { useEffect, useState, useContext } from 'react'
import { Helmet } from "react-helmet";
import { useNavigate } from 'react-router-dom';
import { SearchCustomer } from 'services/Api/Module/Customer';
import helper from 'services/helper';
import useTranslations from 'i18n/useTranslations';

const Verified = () => {
    const navigate = useNavigate();
    const { t } = useTranslations();
    const { mAlert } = useContext(ModalContext);
    const [contactNumber, setContactNumber] = useState('');
    const [isFail, setIsFail] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false);
    const handleBack = () => {
        navigate("/")
    }
    const handleNext = () => {
        const payload = {
            contactNumber: contactNumber
        }
        fetchSearchCustomer(payload)
    }
    const fetchSearchCustomer = async (payload) => {
        try {
            const response = await SearchCustomer({ params: payload })
            const resData = response.data
            if (resData.resultCode == "20000") {
                const searchParams = new URLSearchParams(window.location.search);
                searchParams.set('contactNumber', contactNumber);
                navigate(`/verified-otp?${searchParams.toString()}`)
            } else {
                setIsFail(true)
            }
        }
        catch (err) {
            console.log('err ', err)
            mAlert.info({
                title: "แจ้งเตือน",
                subTitle: "มีบางอย่างผิดพลาด",
                content: "",
                onClose: () => { },
            })
        }
    }
    useEffect(() => {
        setIsFormValid(contactNumber.length === 10);
    }, [contactNumber]);
    return (
        <div>
            <Helmet>
                <title>IMPACT Family</title>
                <meta name="title" content="Impact Family" />
                <meta name="description" content="Impact Family" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="Impact Family" />
                <meta property="og:description" content="Impact Family" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Impact Family" />
            </Helmet>
            <div id="pageVerified">
                <Pageheader pagename={t.verified.login} onClick={handleBack} />
                <main id="top">
                    <div className="wrapContent">
                        <section id="pRegister">
                            <div className="bRegisterMain">
                                <form>
                                    <div className="bForm">
                                        <div className="bGroup">
                                            <p dangerouslySetInnerHTML={{ __html: t.verified.phone }}></p>
                                            <div className="bRow">
                                                <div className="control-group">
                                                    <div className="inputPlaceholder">
                                                        <span>080-000-0000</span>
                                                        <input
                                                            type="text"
                                                            inputMode="numeric"
                                                            value={contactNumber}
                                                            onInput={helper.FNFORM.handleNumberOnly}
                                                            onChange={(e) => setContactNumber(e.target.value)}
                                                            maxLength={10}
                                                            name=""
                                                            placeholder="080-000-0000"
                                                        />
                                                    </div>
                                                    <label htmlFor="" className="tError">กรุณากรอกเบอร์โทรศัพท์</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="bBtn">
                                            <button className="btn" onClick={handleNext} type="button" disabled={!isFormValid}>{t.verified.next}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </section>
                    </div>
                </main>
                <ModalMemberNotFound open={isFail} onClose={() => setIsFail(false)} />

            </div>
        </div>
    )
}

export default Verified